import BackdropMUI from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'

const Backdrop = () => {
  return (
    <BackdropMUI
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: 'background.default'
      }}
      open={true}
    >
      <CircularProgress color='primary' />
    </BackdropMUI>
  )
}

export default Backdrop
